module.exports = __webpack_public_path__ + "img/associationMapWhite.af96abe5.svg";